export default __webpack_public_path__ + "static/media/recordedvideo_icon.79516bad.svg";